import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById, putData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { GeneralDiscountForm } from "./components/generalDiscountForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const EditGeneralDiscount = () => {

  const navigate = useNavigate();
  const params = useParams();
  const paramId = params.id;
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [discountData, setDiscountData] = useState(null);


  useEffect(() => {
    const fetchData = async () => {

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/general/discount/${paramId}`).then((res) => {
            const responseData = res?.data?.discount;
            setDiscountData((prevData) => ({
              ...prevData,
              name: responseData?.name,
              maxLimit: responseData?.maxLimit,
              description: responseData?.description,
              productId: {label: responseData?.product?.keyName, value: responseData?.product?.id},
              policyTypeId: {label: responseData?.policyType?.keyName, value: responseData?.policyType?.id},
              autoApply: responseData?.autoApply,
              mandatory: responseData?.mandatory,
              active: responseData?.isActive,

              // discount information status
              nameStatus: responseData?.name ? "success" : "unchecked",
              maxLimitStatus: responseData?.maxLimit ? "success" : "unchecked",
              descriptionStatus: responseData?.description ? "success" : "unchecked",
              productIdStatus: responseData?.product?.id ? "success" : "unchecked",
              policyTypeIdStatus: responseData?.policyType?.id ? "success" : "unchecked",
            }));
          });
        } catch (error) {
          console.error(error);
          showSnackbar(error?.response?.data?.message, "error");
        }finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [paramId]);


  const handleUpdateDiscount = async (discountData) => {
    const payload = {
        name: discountData?.name,
        description: discountData?.description,
        maxLimit: discountData?.maxLimit,
        autoApply: discountData?.autoApply,
        mandatory: discountData?.mandatory,
        isActive: discountData?.active,
        productId: discountData?.productId?.value,
        policyTypeId: discountData?.policyTypeId?.value    
    };
    try {
      const response = await putData(`/reference/general/discount/${paramId}`, payload);
      if(response?.success){
        navigate("/general-master/general-discount");
        showSnackbar(response?.message,"success")
      }
      else{
        showSnackbar("Error Updating","error");
      }

    } catch (error) {
      console.error("Error Updating Data:",error)
      showSnackbar(error?.response?.data?.message, "error");
    }finally{
      setCircleLoading(false)
    }
    };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/general-master/general-discount")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Discount details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Discount details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <GeneralDiscountForm onsubmit={handleUpdateDiscount} editDiscountData={discountData} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditGeneralDiscount;
